import {styled} from '@mui/material/styles';

import {BasicTreeViewSelectionOptions, TreeViewSectionConfig} from 'filters/features/FilterDialog/types';
import {BasicTreeDataOptions} from 'modules/decisionsNext/hooks/trees/types';

import {useEditedFilterContext} from 'filters/features/FilterDialog/contexts/internal/EditedFilterProvider/EditedFilterProvider';

import {TreeBasicNode, TreeKey} from 'components/Tree/TreeTypes';
import {FilterTreePicker} from 'components/TreePicker/FilterTreePicker';

export const createTreeViewSection = <
  V,
  K extends TreeKey,
  Node extends TreeBasicNode<K>,
  TDO extends BasicTreeDataOptions,
  TSO extends BasicTreeViewSelectionOptions
>(
  config: Omit<TreeViewSectionConfig<V, K, Node, TDO, TSO>, 'type'>
): TreeViewSectionConfig<V, K, Node, TDO, TSO> => {
  return {
    ...config,
    type: 'tree-view',
  };
};

const SRoot = styled('div')(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const TreeViewSection = ({
  title,
  entity,
  getDataOptions,
  selectionOptions = {},
  getValue,
  onChange,
  useTreeData,
  useTreeSelection,
}: TreeViewSectionConfig<any, any, any, any, any>) => {
  const {filter, setFilter} = useEditedFilterContext();

  const value = getValue(filter);

  const treeData = useTreeData({
    ...getDataOptions?.(value),
    skip: false,
  });

  const {
    overrideActiveFilterContent: _,
    isAllSelected: __,
    ...selection
  } = useTreeSelection(
    treeData,
    {
      value,
      setValue: value => setFilter(prev => onChange(prev, value)),
    },
    selectionOptions
  );

  return (
    <SRoot>
      <FilterTreePicker
        isLoading={treeData.loading}
        treeData={treeData.treeData}
        entity={entity || title}
        {...(selection as any)}
        selectionCount={selection.selectionCount || 'All'}
      />
    </SRoot>
  );
};
